import sowosWealthTypes from './sowos-wealth/types';
import sowosPocketWithdrawalTypes from './sowos-pocket/withdrawal/types';

export default {
  ...sowosWealthTypes,
  ...sowosPocketWithdrawalTypes,
};
